"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FirstPageIcon_1 = __importDefault(require("mdi-react/FirstPageIcon"));
var KeyboardArrowLeftIcon_1 = __importDefault(require("mdi-react/KeyboardArrowLeftIcon"));
var KeyboardArrowRightIcon_1 = __importDefault(require("mdi-react/KeyboardArrowRightIcon"));
var LastPageIcon_1 = __importDefault(require("mdi-react/LastPageIcon"));
var react_1 = __importDefault(require("react"));
var IconButton_1 = require("../IconButton");
var styles_1 = require("../styles");
var Tooltip_1 = require("../Tooltip");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    root: {
        flexShrink: 0,
        color: theme.palette.primary.contrastText,
        marginLeft: theme.spacing(2.5),
        marginRight: theme.spacing(1.5),
    },
}); });
function DataGridPaginationActions(_a) {
    var t = _a.t, count = _a.count, onChangePage = _a.onChangePage, onPageChange = _a.onPageChange, page = _a.page, rowsPerPage = _a.rowsPerPage;
    var classes = useStyles();
    var theme = (0, styles_1.useTheme)();
    var handleFirstPageButtonClick = function (event) {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(event, 0);
        onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(event, page - 1);
        onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(event, page + 1);
        onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        var newPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(event, newPage);
        onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(event, newPage);
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(Tooltip_1.Tooltip, { title: theme.direction === 'rtl' ? t('dt-lastPage') : t('dt-firstPage') },
            react_1.default.createElement("span", null,
                react_1.default.createElement(IconButton_1.IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, color: "inherit", "aria-label": theme.direction === 'rtl' ? t('dt-lastPage') : t('dt-firstPage') }, theme.direction === 'rtl' ? (react_1.default.createElement(LastPageIcon_1.default, null)) : (react_1.default.createElement(FirstPageIcon_1.default, null))))),
        react_1.default.createElement(Tooltip_1.Tooltip, { title: theme.direction === 'rtl' ? t('dt-nextPage') : t('dt-previousPage') },
            react_1.default.createElement("span", null,
                react_1.default.createElement(IconButton_1.IconButton, { onClick: handleBackButtonClick, disabled: page === 0, color: "inherit", "aria-label": theme.direction === 'rtl'
                        ? t('dt-nextPage')
                        : t('dt-previousPage') }, theme.direction === 'rtl' ? (react_1.default.createElement(KeyboardArrowRightIcon_1.default, null)) : (react_1.default.createElement(KeyboardArrowLeftIcon_1.default, null))))),
        react_1.default.createElement(Tooltip_1.Tooltip, { title: theme.direction === 'rtl' ? t('dt-previousPage') : t('dt-nextPage') },
            react_1.default.createElement("span", null,
                react_1.default.createElement(IconButton_1.IconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, color: "inherit", "aria-label": theme.direction === 'rtl'
                        ? t('dt-previousPage')
                        : t('dt-nextPage') }, theme.direction === 'rtl' ? (react_1.default.createElement(KeyboardArrowLeftIcon_1.default, null)) : (react_1.default.createElement(KeyboardArrowRightIcon_1.default, null))))),
        react_1.default.createElement(Tooltip_1.Tooltip, { title: theme.direction === 'rtl' ? t('dt-firstPage') : t('dt-lastPage') },
            react_1.default.createElement("span", null,
                react_1.default.createElement(IconButton_1.IconButton, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, color: "inherit", "aria-label": theme.direction === 'rtl' ? t('dt-firstPage') : t('dt-lastPage') }, theme.direction === 'rtl' ? (react_1.default.createElement(FirstPageIcon_1.default, null)) : (react_1.default.createElement(LastPageIcon_1.default, null)))))));
}
exports.default = DataGridPaginationActions;
//# sourceMappingURL=DataGridPaginationActions.js.map